import { Button } from "@/components/Button";
import { HeaderTextBlock } from "@/components/Typography";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { faCaretLeft } from "@fortawesome/pro-solid-svg-icons";
import PolicyEditor from "@/routes/Comply/Policies/Manage/PolicyEditorForm";
import { useGetPoliciesTable } from "@/requests/hooks/comply";
import { useEffect, useState } from "react";
import PolicyEditorFormLoader from "@/routes/Comply/Policies/Manage/PolicyEditorFormLoader";

interface IProps {
  updateType: "EDIT" | "ADD";
  policyType: "PDF" | "TEXT";
}

const ManagePolicy = ({ updateType, policyType }: IProps) => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [existingPolicy, setExistingPolicy] = useState<IPolicy | undefined>();
  const { data: policies, isFetching: isFetchingGetPolicies } =
    useGetPoliciesTable({
      enabled: true,
      queryKey: ["comply", "list-policies", state],
      params: {},
    });

  useEffect(() => {
    const foundExistingPolicy: IPolicy | undefined = policies?.results?.find(
      (policy: IPolicy) => policy?.id?.toString() === id,
    );

    if (!foundExistingPolicy) return;

    setExistingPolicy(foundExistingPolicy);
  }, [policies]);

  const goBackToPolicies = () => {
    navigate("/comply/policies" + (!!state ? state : ""));
  };

  const renderHeaderTextBlock = () => {
    let headingText = t("comply.policies.edit.title");
    let descriptionText = t("comply.policies.edit.description");

    if (updateType === "ADD") {
      headingText = t("comply.policies.add.title");
      descriptionText = t("comply.policies.add.description");
    }

    return (
      <div className="mb-30">
        <HeaderTextBlock
          featureText={t("comply.policies.header.heading")}
          headingText={headingText}
          descriptionText={descriptionText}
        />
      </div>
    );
  };

  const renderBackButton = () => (
    <div className="mb-20">
      <Button
        as="button"
        variant="link"
        icon={faCaretLeft}
        iconPosition="start"
        iconClassName="h-20 w-20"
        onClick={goBackToPolicies}>
        {t("comply.policies.common.back")}
      </Button>
    </div>
  );

  const renderPolicyEditorOrLoader = () => {
    if (isFetchingGetPolicies || (updateType === "EDIT" && !existingPolicy))
      return <PolicyEditorFormLoader updateType={updateType} />;

    return (
      <PolicyEditor
        updateType={updateType}
        policyType={policyType}
        existingPolicy={existingPolicy}
      />
    );
  };
  return (
    <>
      {renderHeaderTextBlock()}
      {renderBackButton()}
      {renderPolicyEditorOrLoader()}
    </>
  );
};

export default ManagePolicy;
